import { render, staticRenderFns } from "./MenuSidebarLayer.vue?vue&type=template&id=5288d5fd&scoped=true&"
import script from "./MenuSidebarLayer.vue?vue&type=script&lang=js&"
export * from "./MenuSidebarLayer.vue?vue&type=script&lang=js&"
import style0 from "./MenuSidebarLayer.vue?vue&type=style&index=0&id=5288d5fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5288d5fd",
  null
  
)

export default component.exports